import {
  SaleSettingsEditableInterface,
  SaleSettingsViewInterface,
} from 'modules/funnels/types/sale-settings-interface'
import httpClient from 'shared/utils/http-client'

export const SALES_SETTINGS_API = '/api/dashboard/customer/sale-settings'

export const updateSaleSettings = (id: string, data: SaleSettingsEditableInterface) =>
  httpClient.put<SaleSettingsViewInterface>(`${SALES_SETTINGS_API}/${id}`, data)
